import { isAuthenticated } from "@/routers/router-guardians"

const routes = [
  {
    path: "/dashboard/async-appointments",
    name: "async-appointment-list",
    component: () => import("@/modules/async-appointment/pages/async-appointment-list/AsyncVisitListPage.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  },
  {
    path: "/dashboard/async-appointments/:id",
    name: "async-appointment-details",
    component: () =>
      import("@/modules/async-appointment/pages/async-appointment-details/AsyncAppointmentDetailsPage.vue"),
    props: (route) => ({ asyncAppointmentId: route.params.id }),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
